import { IRequestUpdateLogoAccepted } from '../../../actions/userObject/profile/requestUpdateLogo'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IRequestUpdateLogoAccepted,
): IUserObjectStore {
  return {
    ...state,
    profileRequest: {
      ...state.profileRequest,
      isLoading: false,
    },
    userObject: {
      ...state.userObject,
      profile: {
        ...state.userObject.profile,
        logoUrl: action.profile.logoUrl,
      },
    },
  }
}
